import * as React from "react";
import { QuestionsIF } from "../../QuestionsIF";
import { UnitConverter } from "./numericInput";
import { MeasurementUnits } from "fe-common/graphql";
import { GeneralNumericQuestion } from "./generalNumericQuestion";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface FeverQuestionProps extends QuestionsIF {
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]

//endregion [[ Functions ]]

const feverUnitConverts: UnitConverter[] = [
  {
    unit: MeasurementUnits.Celsius,
    converters: [
      {
        from: MeasurementUnits.Fahrenheit,
        converter: (temp: number) => ((temp - 32) * 5) / 9,
      },
    ],
  },
  {
    unit: MeasurementUnits.Fahrenheit,
    converters: [
      {
        from: MeasurementUnits.Celsius,
        converter: (temp: number) => (temp * 9) / 5 + 32,
      },
    ],
  },
];

export const FeverQuestion = (props: FeverQuestionProps) => {
  return <GeneralNumericQuestion {...props} converters={feverUnitConverts} />;
};
